import { Pipe, PipeTransform } from "@angular/core";
import { DeviceShadow } from "../models/shadow/device-shadow";
import { Versioning } from "../utils/versioning";
import { v2CallVersion } from "../constants";

@Pipe({ name: "deviceSupportCallv2" })
export class DeviceSupportCallv2Pipe implements PipeTransform {
  
  transform(value: DeviceShadow): boolean {
    const applicationVersion = value?.device?.version?.application;
    const version = applicationVersion != null ? new Versioning(applicationVersion) : null;
    return version != null && version.compareTo(v2CallVersion) >= 0;
  }

}
